import { ConnectionOptions, GraphApiMethod } from '@/api/core';
import { CreateIncidentIssueInput, CreateIncidentIssueResponse, MutationCreateIncidentIssueBulkArgs } from '@/models/gen/graphql';
import createGraphApiHook, { CreateGraphApiHookHook } from '@/hooks/createGraphApiHook';

import { CreateIncidentIssue } from '@/features/IncidentHistory/api/queries/CreateIncidentIssue';
import { TypedDocumentNode } from '@apollo/client';
import { getProperty } from '@/utils';
import graphApi from '@/api';

// Service Function Signature
type ServiceMethodPayload = {
  [key in keyof CreateIncidentIssueInput]?: any;
}[];
interface ServiceMethod {
  (payload?: ServiceMethodPayload, options?: ConnectionOptions): Promise<CreateIncidentIssueResponse>;
}

// CreateIncidentIssue Service
export const { createIncidentIssue, useCreateIncidentIssue } = ((): {
  createIncidentIssue: ServiceMethod;
  useCreateIncidentIssue: CreateGraphApiHookHook<ServiceMethod>;
} => {
  const [fetch] = graphApi(CreateIncidentIssue).map(
    (fn: GraphApiMethod<TypedDocumentNode>): ServiceMethod =>
      async (payload?: CreateIncidentIssueInput[], options?: ConnectionOptions): Promise<CreateIncidentIssueResponse> => {
        debug.log('createIncidentIssue,createIncidentIssue.input', 'INPUT', payload);
        const values: CreateIncidentIssueInput[] = payload.map(
          (item: CreateIncidentIssueInput): CreateIncidentIssueInput => ({
            crewInfo: item?.crewInfo || null,
            crewInvolved: item?.crewInvolved || null,
            description: item?.description || null,
            dispatcherId: item?.dispatcherId || null,
            driverId: item?.driverId || null,
            incidentDatetime: item?.incidentDatetime || null,
            incidentOccurance: item?.incidentOccurance || null,
            incidentOccuranceOther: item?.incidentOccuranceOther || null,
            incidentWitnesses: item?.incidentWitnesses || null,
            managerId: item?.managerId || null,
            medicalAttentionType: item?.medicalAttentionType || null,
            medicalInjuries: item?.medicalInjuries || null,
            medicalNeeded: item?.medicalNeeded || null,
            outboundDatetime: item?.outboundDatetime || null,
            outboundFlightNumber: item?.outboundFlightNumber || null,
            outboundFlightName: item?.outboundFlightName || null,
            propertyDamage: item?.propertyDamage || null,
            propertyDamageDescription: item?.propertyDamageDescription || null,
            recoveryInfo: item?.recoveryInfo || null,
            samsaraCameraWorking: item?.samsaraCameraWorking || null,
            station: item?.station || null,
            traceId: item?.traceId || null,
            tripId: item?.tripId || null,
            vehicleId: item?.vehicleId || null,
            documents: item?.documents || [],
          })
        );
        const args: MutationCreateIncidentIssueBulkArgs = {
          input: {
            values,
          },
        };
        debug.log('createIncidentIssue,createIncidentIssue.payload', 'PAYLOAD', args);
        const opts = { merge: options?.merge ? 'createIncidentIssueBulk' : undefined };
        const res = await fn(args, opts);
        debug.log('createIncidentIssue,createIncidentIssue.response', 'RESPONSE', res);
        return getProperty('createIncidentIssueBulk.output', res);
      }
  );
  const useService = createGraphApiHook(fetch);
  return {
    createIncidentIssue: fetch,
    useCreateIncidentIssue: useService,
  };
})();
